function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M509.107,130.133l-145.067-128c-1.741-1.536-3.968-2.236-6.101-2.116L8.533,0C6.263,0,4.096,0.896,2.5,2.5 C0.905,4.105,0,6.263,0,8.533v358.4c0,4.719,3.814,8.533,8.533,8.533h179.2c0.205,0,0.384-0.102,0.58-0.119 c18.765,20.966,45.935,34.253,76.22,34.253c13.909,0,27.179-2.816,39.279-7.859l90.735,107.238 c1.63,1.911,4.011,3.021,6.519,3.021c27.844,0,42.667-19.823,42.667-34.133c0-2.014-0.717-3.977-2.014-5.513l-81.988-96.888 h143.735c4.719,0,8.533-3.814,8.533-8.533v-230.4C512,134.084,510.95,131.755,509.107,130.133z M366.933,27.443L480.896,128 H366.933V27.443z M264.533,392.533c-47.053,0-85.333-38.281-85.333-85.333s38.281-85.333,85.333-85.333 s85.333,38.281,85.333,85.333S311.586,392.533,264.533,392.533z M426.18,480.427c-1.638,5.009-7.697,13.047-21.308,14.336 l-85.598-101.171c7.228-4.599,13.824-10.061,19.678-16.265L426.18,480.427z M494.933,358.4h-141.85 c8.755-15.078,13.85-32.538,13.85-51.2c0-56.465-45.935-102.4-102.4-102.4c-56.465,0-102.4,45.935-102.4,102.4 c0,18.662,5.094,36.122,13.85,51.2H17.067V17.067l332.8,0.017v119.45c0,4.719,3.814,8.533,8.533,8.533h136.533V358.4z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Layer_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: 24,
  hight: 24,
  viewBox: "0 0 512 512",
  style: {
    "enableBackground": "new 0 0 512 512"
  },
  xmlSpace: "preserve"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);

export default __webpack_public_path__ + "static/media/icon.9db07225.svg";
export { SvgComponent as ReactComponent };